import React, { forwardRef } from 'react';
import { IconButton, type IconButtonProps } from '@atlaskit/button/new';
import SprintIcon from '@atlaskit/icon/glyph/sprint';
import type { TriggerProps } from '@atlaskit/popup';

const TOOLTIP_OPTIONS: IconButtonProps['tooltip'] = {
	hideTooltipOnClick: true,
};

type Props = Partial<Omit<TriggerProps, 'ref'>> & Pick<IconButtonProps, 'isSelected' | 'onClick'>;

const SprintButton = forwardRef((extraProps: Props, ref: React.Ref<HTMLButtonElement>) => {
	return (
		<IconButton
			ref={ref}
			icon={SprintIcon}
			appearance="subtle"
			label="Sprint details TODO i18n message"
			isTooltipDisabled={false}
			tooltip={TOOLTIP_OPTIONS}
			{...extraProps}
		/>
	);
});

export default SprintButton;
